import React, { Dispatch, SetStateAction } from "react";
import "./css/index.css";

type Props = {
  setType: Dispatch<SetStateAction<"normal" | "line">>;
  type: "normal" | "line";
};

const AddNavSection = ({ setType, type }: Props) => {
  return (
    <div className="add-nav-section">
      <div className="title">광고리스트</div>
      <ul className="banner">
        <button
          className={type === "normal" ? "active" : ""}
          onClick={() => {
            setType("normal");
          }}
        >
          메인배너
        </button>
        <button
          className={type === "line" ? "active" : ""}
          onClick={() => {
            setType("line");
          }}
        >
          띠배너
        </button>
      </ul>
      <div className="line"></div>
    </div>
  );
};

export default AddNavSection;
